// This should come from the database

const menu = (role) => {
  const menuItems = [
    {
      id: 1,
      label: "Candidaturas",
      icon: "UserMultiple16",
      roles: ["200", "201", "202", "203", "204", "207"],

      items: [
        {
          id: 1.1,
          label: "Registar",
          link: "/admin/registar-candidatura",
          roles: ["201", "202"],
        },
        {
          id: 1.2,
          label: "Consultar",
          link: "/admin/candidaturas",

          roles: ["202", "203", "207"],

          roles: ["200", "202", "203"],
        },
        // {
        //   id: 1.3,
        //   label: "Triagem Preliminar",
        //   link: "/admin/triagem-de-candidaturas",

        //   roles: ["202"],

        //   roles: ["200", "202"],

        // },
        {
          id: 1.4,
          label: "Painel de Júri",
          link: "/admin/painel-de-juri",
          roles: ["200", "202"],
        },
        {
          id: 1.5,
          label: "Avaliação",
          link: "/admin/avaliacao-de-candidaturas",
          roles: ["204"],
        },
        {
          id: 1.6,
          label: "Ranking",
          link: "/admin/ranking-de-candidaturas",
          roles: ["200", "202"],
        },

        // {
        //   id: 1.7,
        //   label: "Desempate",
        //   link: "/admin/desempate-de-pontuacao",
        //   roles: ["202"],
        // },

        {
          id: 1.7,
          label: "Desempate",
          link: "/admin/desempate-de-pontuacao",
          roles: ["200", "202"],
        },

        // {
        //   id: 1.7,
        //   label: "Validação",
        //   link: "/admin/validacao-de-candidaturas",
        //   roles: ["3"],
        // },
        // {
        //   id: 1.8,
        //   label: "Minha Candidatura",
        //   link: "/admin/inicio",
        //   roles: ["201"],
        // },
      ],
    },

    {
      id: 2,
      label: "Planos de Negócio",
      icon: "UserMultiple16",
      roles: ["202", "203", "204", "207", "201"],
      items: [
        {
          id: 2.1,
          label: "Registar",
          link: "/admin/registar-plano-de-negocio",
          roles: ["201"],
        },
        {
          id: 2.2,
          label: "Consultar",
          link: "/admin/planos-de-negocio",
          roles: ["202", "203", "207"],
        },
        {
          id: 2.3,
          label: "Painel de Júri",
          link: "/admin/painel-de-juri-planos-de-negocio",
          roles: ["202"],
        },
        {
          id: 2.4,
          label: "Avaliação",
          link: "/admin/planos-de-negocio-do-juri",
          roles: ["204"],
        },
        {
          id: 1.6,
          label: "Ranking",
          link: "/admin/ranking-de-planos-de-negocio",
          roles: ["202"],
        },
        // {
        //   id: 2.3,
        //   label: "Meu Plano de Negócio",
        //   link: "/admin/meu-plano-de-negocio",
        //   roles: ["2"],
        // },
      ],
    },
    {
      id: 3,
      label: "Estágios",
      icon: "UserMultiple16",
      roles: ["200", "201", "202", "207", "208", "209"],
      items: [
        {
          id: 3.1,
          label: "Vagas",
          link: "/admin/vagas-para-estagio",
          roles: ["200", "201", "202", "207", "208", "209"],
        },
        {
          id: 3.2,
          label: "Candidatos",
          link: "/admin/candidaturas-para-estagio",
          roles: ["200", "201", "202", "209"],
        },
        // {
        //   id: 3.3,
        //   label: "Ranking de candidatos",
        //   link: "/admin/ranking-candidatos-para-estagio",
        //   roles: ["200", "201", "202", "207", "208", "209"],
        // },
      ],
    },

    // {
    //   id: 2,
    //   label: "Planos de Negócio",
    //   icon: "UserMultiple16",
    //   roles: ["201", "202", "203", "204"],
    //   items: [
    //     {
    //       id: 2.1,
    //       label: "Registar",
    //       link: "/admin/registar-plano-de-negocio",
    //       roles: ["201"],
    //     },
    //     {
    //       id: 2.2,
    //       label: "Consultar",
    //       link: "/admin/planos-de-negocio",
    //       roles: ["202"],
    //     },
    //     {
    //       id: 2.3,
    //       label: "Painel de Júri",
    //       link: "/admin/painel-de-juri-planos-de-negocio",
    //       roles: ["202"],
    //     },
    //     {
    //       id: 2.4,
    //       label: "Avaliação",
    //       link: "/admin/planos-de-negocio-do-juri",
    //       roles: ["204"],
    //     },
    //     // {
    //     //   id: 2.3,
    //     //   label: "Meu Plano de Negócio",
    //     //   link: "/admin/meu-plano-de-negocio",
    //     //   roles: ["2"],
    //     // },
    //   ],
    // },
    // {
    //   id: 3,
    //   label: "Contratos",
    //   icon: "UserMultiple16",
    //   roles: ["200", "201", "202", "203"],
    //   items: [
    //     {
    //       id: 3.1,
    //       label: "Meu Contrato",
    //       link: "/admin/meu-contrato",
    //       roles: ["201"],
    //     },
    //     {
    //       id: 3.2,
    //       label: "Consultar",
    //       link: "/admin/contratos",
    //       roles: ["200", "202", "207", "208"],
    //     },
    //   ],
    // },

    {
      id: 4,
      label: "Reclamações",
      icon: "UserMultiple16",
      roles: ["200", "202", "205", "206"],
      items: [
        {
          id: 4.1,
          label: "Consultar",
          link: "/admin/reclamacoes",
          roles: ["200", "202", "205", "206"],
        },
      ],
    },
    {
      id: 5,
      label: "Utilizadores",
      icon: "UserMultiple16",
      roles: ["200"],
      items: [
        {
          id: 5.1,
          label: "Registar",
          link: "/admin/registar-utilizador",
          roles: ["200"],
        },
        {
          id: 5.2,
          label: "Consultar",
          link: "/admin/utilizadores",
          roles: ["200"],
        },
        // {
        //   id: 5.3,
        //   label: "Minha conta",
        //   link: "/admin/minha-conta",
        //   roles: ["1", "2", "3", "4", "5", "6", "7"],
        // },
      ],
    },
    // {
    //   id: 6,
    //   label: "Configurações",
    //   icon: "UserMultiple16",
    //   roles: ["200"],
    //   items: [
    //     // {
    //     //   id: 6.1,
    //     //   label: "Gerir",
    //     //   link: "/admin/gerir-configuracoes",
    //     //   roles: ["1"],
    //     // },
    //   ],
    // },
  ];

  const userMenu = menuItems.filter((m) => m.roles.includes(role));
  userMenu.forEach((menu) => {
    menu.items = menu.items.filter((mi) => mi.roles.includes(role));
  });

  return userMenu;
};

export default menu;
